<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getUser(to.params.id)
      vm.getTodos(to.params.id)
    })
  },
  methods: {
    getUser (id) {
      this.$store.dispatch('getUser', id)
    },
    getTodos (id) {
      this.$store.dispatch('getTodos', id)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Todos.vue?0ef67c9a